import createIcon from '../../createIcon';

/**
 * @component @name SwipeLeft
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuOTggMTYuODJMMTkuMzUgMjEuMjhDMTkuMjEgMjIuMjcgMTguMzYgMjMgMTcuMzcgMjNIMTEuMjFDMTAuNjggMjMgOS45MiAyMi43OSA5LjU1IDIyLjQxTDUgMTcuNjJMNS44MyAxNi43OEM2LjA3IDE2LjU0IDYuNDEgMTYuNDMgNi43NSAxNi41TDEwIDE3LjI0VjYuNUMxMCA1LjY3IDEwLjY3IDUgMTEuNSA1QzEyLjMzIDUgMTMgNS42NyAxMyA2LjVWMTIuNUgxMy45MUMxNC4yMiAxMi41IDE0LjUzIDEyLjU3IDE0LjggMTIuNzFMMTguODkgMTQuNzVDMTkuNjYgMTUuMTQgMjAuMSAxNS45NyAxOS45OCAxNi44MlpNMTIgMi41QzE2Ljc0IDIuNSAxOS42NyA1LjAyIDIwLjQzIDdIMjJDMjEuMjcgNC4xMiAxNy40OSAxIDEyIDFDOC43OCAxIDUuODIgMi4xMyAzLjUgNC4wMlYySDJWN0g3VjUuNUg0LjA5QzYuMjEgMy42NCA4Ljk3IDIuNSAxMiAyLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SwipeLeft = createIcon('SwipeLeft', [
  [
    'path',
    {
      d: 'M19.98 16.82L19.35 21.28C19.21 22.27 18.36 23 17.37 23H11.21C10.68 23 9.92 22.79 9.55 22.41L5 17.62L5.83 16.78C6.07 16.54 6.41 16.43 6.75 16.5L10 17.24V6.5C10 5.67 10.67 5 11.5 5C12.33 5 13 5.67 13 6.5V12.5H13.91C14.22 12.5 14.53 12.57 14.8 12.71L18.89 14.75C19.66 15.14 20.1 15.97 19.98 16.82ZM12 2.5C16.74 2.5 19.67 5.02 20.43 7H22C21.27 4.12 17.49 1 12 1C8.78 1 5.82 2.13 3.5 4.02V2H2V7H7V5.5H4.09C6.21 3.64 8.97 2.5 12 2.5Z',
      key: 'zhns8q',
    },
  ],
]);

export default SwipeLeft;
